var _rect, _g, _defs, _rect2, _rect3, _rect4, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _defs2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconPlanetWithStars = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    height = 83,
    titleId,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 161 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 161,
    height: 83
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Screen",
    clipPath: "url(#clip0_5737_11320)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 900,
    transform: "translate(-1237 -260)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5737_11320)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 533.5,
    height: 772,
    transform: "translate(-186.5 -144)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.6211 30.5C21.7873 30.5 23.1676 29.1815 23.1676 26C23.1676 29.1815 24.5383 30.5 27.7141 30.5C24.5383 30.5 23.1676 31.8567 23.1676 35C23.1676 31.8567 21.7873 30.5 18.6211 30.5Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.746 58.5C131.912 58.5 133.293 57.1815 133.293 54C133.293 57.1815 134.663 58.5 137.839 58.5C134.663 58.5 133.293 59.8567 133.293 63C133.293 59.8567 131.912 58.5 128.746 58.5Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 135.789,
    cy: 9.58552,
    rx: 1.60191,
    ry: 1.58552,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.161,
    cy: 19.5855,
    rx: 1.60191,
    ry: 1.58552,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.4378,
    cy: 12.5855,
    rx: 1.60191,
    ry: 1.58552,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 159.303,
    cy: 32.5725,
    rx: 0.947469,
    ry: 0.937778,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 131.436,
    cy: 35.7347,
    rx: 0.947469,
    ry: 0.937778,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.1975,
    cy: 40.9378,
    rx: 0.947469,
    ry: 0.937778,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.19747,
    cy: 20.178,
    rx: 0.947469,
    ry: 0.937778,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.1506,
    cy: 56.1097,
    rx: 0.947469,
    ry: 0.937778,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.51207,
    cy: 66.6656,
    rx: 1.60191,
    ry: 1.58552,
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M96.024 28.005C102.61 26.4611 107.331 26.64 108.457 28.8982C110.552 33.1001 99.4062 42.9101 83.5626 50.8094C67.719 58.7088 53.1769 61.7061 51.0819 57.5042C49.9587 55.2514 52.6414 51.3866 57.8135 47.0685",
    stroke: "currentColor",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.069 44.1597C103.069 56.7701 92.8463 66.9931 80.2358 66.9931C67.6252 66.9931 57.4023 56.7701 57.4023 44.1597C57.4023 31.5491 67.6252 21.3262 80.2358 21.3262",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3127 25.8752C89.9164 28.6308 93.9547 27.0537 96.7522 20.3494C93.9547 27.0537 95.6543 31.025 102.278 33.7889C95.6543 31.025 91.6024 32.6909 88.8385 39.3147C91.6024 32.6909 89.9164 28.6308 83.3127 25.8752Z",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5831 15.8354C85.5747 15.7993 87.2997 14.1042 87.2631 10.0517C87.2997 14.1042 89.043 15.7679 93.0468 15.7317C89.043 15.7679 87.3305 17.5116 87.3667 21.5154C87.3305 17.5116 85.5747 15.7993 81.5831 15.8354Z",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })))))))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5737_11320"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 900,
    transform: "translate(-1237 -260)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5737_11320"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 533.5,
    height: 772,
    transform: "translate(-186.5 -144)"
  })))));
});
export const Icon = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    className: propClassName = "",
    fill = "none",
    stroke = "currentColor",
    weight = "normal",
    height = 83,
    titleId,
    title,
    ...props
  } = _ref2;
  const className = "vector-effect-non-scaling-stroke " + propClassName;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 161 83",
    fill: fill,
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 161,
    height: 83
  })), /*#__PURE__*/React.createElement("g", {
    id: "Screen",
    clipPath: "url(#clip0_5737_11320)"
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 900,
    transform: "translate(-1237 -260)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5737_11320)"
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 533.5,
    height: 772,
    transform: "translate(-186.5 -144)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.6211 30.5C21.7873 30.5 23.1676 29.1815 23.1676 26C23.1676 29.1815 24.5383 30.5 27.7141 30.5C24.5383 30.5 23.1676 31.8567 23.1676 35C23.1676 31.8567 21.7873 30.5 18.6211 30.5Z",
    fill: "currentColor",
    stroke: stroke,
    strokeWidth: weight === "normal" ? 1.5 : 1,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.746 58.5C131.912 58.5 133.293 57.1815 133.293 54C133.293 57.1815 134.663 58.5 137.839 58.5C134.663 58.5 133.293 59.8567 133.293 63C133.293 59.8567 131.912 58.5 128.746 58.5Z",
    fill: "currentColor",
    stroke: stroke,
    strokeWidth: weight === "normal" ? 1.5 : 1,
    strokeLinejoin: "round"
  }), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 135.789,
    cy: 9.58552,
    rx: 1.60191,
    ry: 1.58552,
    fill: "currentColor"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.161,
    cy: 19.5855,
    rx: 1.60191,
    ry: 1.58552,
    fill: "currentColor"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.4378,
    cy: 12.5855,
    rx: 1.60191,
    ry: 1.58552,
    fill: "currentColor"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 159.303,
    cy: 32.5725,
    rx: 0.947469,
    ry: 0.937778,
    fill: "currentColor"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 131.436,
    cy: 35.7347,
    rx: 0.947469,
    ry: 0.937778,
    fill: "currentColor"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.1975,
    cy: 40.9378,
    rx: 0.947469,
    ry: 0.937778,
    fill: "currentColor"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.19747,
    cy: 20.178,
    rx: 0.947469,
    ry: 0.937778,
    fill: "currentColor"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.1506,
    cy: 56.1097,
    rx: 0.947469,
    ry: 0.937778,
    fill: "currentColor"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.51207,
    cy: 66.6656,
    rx: 1.60191,
    ry: 1.58552,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M96.024 28.005C102.61 26.4611 107.331 26.64 108.457 28.8982C110.552 33.1001 99.4062 42.9101 83.5626 50.8094C67.719 58.7088 53.1769 61.7061 51.0819 57.5042C49.9587 55.2514 52.6414 51.3866 57.8135 47.0685",
    stroke: stroke,
    strokeWidth: weight === "normal" ? 1.5 : 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.069 44.1597C103.069 56.7701 92.8463 66.9931 80.2358 66.9931C67.6252 66.9931 57.4023 56.7701 57.4023 44.1597C57.4023 31.5491 67.6252 21.3262 80.2358 21.3262",
    stroke: stroke,
    strokeWidth: weight === "normal" ? 1.5 : 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3127 25.8752C89.9164 28.6308 93.9547 27.0537 96.7522 20.3494C93.9547 27.0537 95.6543 31.025 102.278 33.7889C95.6543 31.025 91.6024 32.6909 88.8385 39.3147C91.6024 32.6909 89.9164 28.6308 83.3127 25.8752Z",
    stroke: stroke,
    strokeWidth: weight === "normal" ? 1.5 : 1,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5831 15.8354C85.5747 15.7993 87.2997 14.1042 87.2631 10.0517C87.2997 14.1042 89.043 15.7679 93.0468 15.7317C89.043 15.7679 87.3305 17.5116 87.3667 21.5154C87.3305 17.5116 85.5747 15.7993 81.5831 15.8354Z",
    stroke: stroke,
    strokeWidth: weight === "normal" ? 1.5 : 1,
    strokeLinejoin: "round"
  }))))))))))))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5737_11320"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 900,
    transform: "translate(-1237 -260)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5737_11320"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 533.5,
    height: 772,
    transform: "translate(-186.5 -144)"
  })))));
});
export default SvgIconPlanetWithStars;
export const raw = __webpack_public_path__ + "static/media/icon-planet-with-stars.c3754c31c1e582ac42aa96219ff6f1e9.svg";